module.exports = __webpack_public_path__ + "img/tv_cultura2.608c3e0c.jpg";